import { render, staticRenderFns } from "./ZBDLDetailInfo.vue?vue&type=template&id=3c1c79a1&scoped=true&"
import script from "./ZBDLDetailInfo.vue?vue&type=script&lang=js&"
export * from "./ZBDLDetailInfo.vue?vue&type=script&lang=js&"
import style0 from "./ZBDLDetailInfo.vue?vue&type=style&index=0&id=3c1c79a1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1c79a1",
  null
  
)

export default component.exports